import { msg } from "@lingui/core/macro";

export const expiryDateBeforeDateRuleMessages = {
	name: msg({ message: "Expiry Date before Date" }),
	description: msg({ message: "Restrict Permit Expiry Date to be before Date" }),
	errors: {
		expiresTooLate: msg({ message: "Permits must expire on or before {time}" }),
		noEndDate: msg({ message: "Permit must have an end date" }),
	},
} as const;
